// https://console.tn-apis.com/store/apis/info?name=CatalogAPI&version=v2
import { formatISO, startOfToday } from 'date-fns'
import type { ApiOptions, TicketNetwork } from './types'
import type { ticketnetwork_events } from '@prisma/client'
import { getGeoFilter } from './utils'
import type { CollectionEntry } from 'astro:content'
const { PUBLIC_TN_URL, PUBLIC_TN_ACCESS_TOKEN, PUBLIC_CHECKOUT_CONFIG_ID } =
	import.meta.env

export async function getToken() {
	let urlParams = new URLSearchParams({
		grant_type: 'client_credentials',
	})

	return fetch(`${PUBLIC_TN_URL}?${urlParams}`, {
		method: 'POST',
		headers: {
			// Authorization: 'Basic ' + `${TN_KEY}:${TN_SECRET}`,
			'Content-Type': 'application/x-www-form-urlencoded',
			mode: 'no-cors',
			Authorization:
				'Basic VzRkbDZ4ZlhNUVRXTUwxNVJzWGtGQUpYZU13YTpFWkJ6R1NYREFuMDk4YmFmNnplQnpYVHliRklh',
		},
	})
		.then((res) => {
			return res.json()
		})
		.then((json) => {
			if (json.results) {
				return json.results || []
			} else {
				return json || {}
			}
		})
}

export const get = async <T>(endpoint, params = {}) => {
	let urlParams = new URLSearchParams({
		websiteConfigId: PUBLIC_CHECKOUT_CONFIG_ID,
		...params,
	})

	return fetch(`${PUBLIC_TN_URL}/${endpoint}?${urlParams}`, {
		headers: {
			Authorization: 'Bearer ' + PUBLIC_TN_ACCESS_TOKEN,
		},
	})
		.then((res) => {
			try {
				return res.json()
			} catch (error) {
				console.error(error)
				return { error: error }
			}
		})
		.then((json) => {
			if (json.results) {
				return json.results || []
			} else {
				return json || {}
			}
		})
}

export const Events = {
	route: 'events',

	get(id): Promise<TicketNetwork.Result> {
		return get(`${this.route}/${id}`)
	},

	getMany(params: ApiOptions = { perPage: 500 }) {
		console.log('getMany', { params })
		console.log(formatISO(startOfToday(), { representation: 'date' }))
		return get(`${this.route}`, {
			filter: `date/date ge ${formatISO(startOfToday(), {
				representation: 'date',
			})}`,
			...params,
		})
	},

	search(params: ApiOptions = {}) {
		console.log('search', { params })
		return get(`events/search`, {
			filter: `date/date ge ${formatISO(startOfToday(), {
				representation: 'date',
			})}`,
			...params,
		})
	},

	suggest(params: ApiOptions = {}) {
		console.log(getGeoFilter(50))
		console.log('suggest', { params })
		return get(`${this.route}/suggest`, {
			...params,
			// filter: getGeoFilter(50),
			filter: `date/date ge ${formatISO(startOfToday(), {
				representation: 'date',
			})}`,
		})
	},
}

export const Performers = {
	route: 'performers',

	get(id: string | number): Promise<TicketNetwork.PerformerResponse> {
		return get(`${this.route}/${id}`)
	},

	getMany(params = {}): Promise<TicketNetwork.EventResponse> {
		return get<TicketNetwork.EventResponse>(`${this.route}`, params)
	},

	suggest(params = {}) {
		return get(`${this.route}/suggest`, params)
	},
}

export const Search = {
	events(params = {}) {
		return get(`events/search`, params)
	},
}

export const Suggest = {
	route: 'suggest',

	getMany() {
		return get(`${this.route}`)
	},
}

export const Venues = {
	route: 'venues',

	get(id): Promise<TicketNetwork.VenueResponse> {
		return get(`${this.route}/${id}`).then((res) => {
			return res
		})
	},

	getMany() {
		return get(`${this.route}`)
	},

	suggest(params = {}) {
		return get(`${this.route}/suggest`, params)
	},
}

export function mapToDb(event: TicketNetwork.Result) {
	const self = event._links?.find((i) => i.rel === 'self')
	const venue = {
		id: +event.venue?.id,
		name: event.venue?.text?.name,
		city: event.city?.text?.name,
		state: event.stateProvince?.text?.abbr,
		country: event.country?.alphaCode,
	}

	// if (!venues.find((v) => venue.id == v.id)) {
	// 	venues.push(venue)
	// }

	let headliner: string | null = null
	let headliner_id: number | null = null

	if (event.performers?.length) {
		let match = event.performers.find((p) =>
			['Headliner', 'Home Team'].includes(p.role),
		)
		if (match) {
			headliner = match.name
			headliner_id = match.id
		} else if (event.performers?.[0]) {
			headliner = event.performers?.[0].name
			headliner_id = event.performers?.[0].id
		}
	}

	let top_category = null

	if (event.defaultCategory?.ancestors?.length) {
		let match = event.defaultCategory?.ancestors.find((c) => c.depth == 1)
		if (match) top_category = match.text?.name
	}

	return {
		id: event.id,
		event_date: new Date(event.date?.datetimeOffset || event.date?.datetime),
		date: event?.date?.date,
		time: event?.date?.time,
		event_name: event.text?.name,
		schedule_status: event.scheduleStatus,
		city: venue.city,
		state: venue.state,
		country: venue.country,
		venue_id: venue.id,
		venue_name: venue.name,
		category: event.defaultCategory?.text?.name,
		event_priority: event.eventPriority,
		performers: event.performers,
		updated_at: new Date(event.updatedAt),
		created_at: new Date(event.createdAt),
		uri_component: event.uriComponent,
		metadata: event._metadata,
		title: self ? self.title : null,
		geo_location: event.geoLocation,
		sales_rank: event.salesRank,
		currency: event.pricingInfo?.lowPrice?.currencyCode,
		low_price: event.pricingInfo?.lowPrice?.value,
		average_price: event.pricingInfo?.averagePrice?.value,
		high_price: event.pricingInfo?.highPrice?.value,
		headliner,
		headliner_id,
		ticket_count: event._metadata?.ticketCount || 0,
		top_category,
	} satisfies Omit<CollectionEntry<'events'>['data'], 'id' | 'slug'> & {
		id: number
	}
}
